/* UpdateCiscoSupportAction.js */

"use strict";

const DEVICE_NAME_MAX_LENGTH = 60;
const DEVICE_NAME_LIST_LENGTH = 10;

class UpdateCiscoSupportAction {
    constructor(logger, gameEditor, modalUserFeedback, activeView, userSession, DeviceEntity) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._activeOrgId = userSession.activeOrganization.id;
        this._DeviceEntity = DeviceEntity;
        this._selectedDeviceIds = [];
        this._selectedDeviceNames = [];

        if (this._activeView && this._activeView.pagingFeed) {
            this._selectedDeviceIds = this._activeView.getSelectedDeviceIds().selectedRows || [];
        }

        this.run = this.run.bind(this);
    }

    run() {
        if (this._selectedDeviceIds.length) {
            return this._activeView.pagingFeed
                .waitForRangeIdsUpdated()
                .then(() => {
                    if (this._selectedDeviceIds.length <= DEVICE_NAME_LIST_LENGTH) {
                        return this._activeView.pagingFeed.getDeviceEntitiesNameById(
                            this._selectedDeviceIds
                        );
                    }
                    return Promise.resolve();
                })
                .then((selectedDeviceNames) => {
                    this._selectedDeviceNames = selectedDeviceNames;
                    if (this._selectedDeviceIds.length <= DEVICE_NAME_LIST_LENGTH) {
                        if (
                            Array.isArray(this._selectedDeviceNames) &&
                            this._selectedDeviceNames.length > 0
                        ) {
                            let s = this._selectedDeviceNames.length > 1 ? "s" : "";
                            this._message =
                                "Support data from a 3rd Party will be updated for the selected device" +
                                s +
                                ". Select Confirm to continue.\n";
                            Object.keys(this._selectedDeviceNames).forEach((id) => {
                                let deviceName = this._selectedDeviceNames[id];
                                let shortDeviceName =
                                    deviceName.length > DEVICE_NAME_MAX_LENGTH
                                        ? deviceName.substr(0, DEVICE_NAME_MAX_LENGTH) + "…"
                                        : deviceName;
                                this._message += "\n" + shortDeviceName;
                            });
                            return Promise.resolve();
                        } else {
                            return Promise.reject(
                                new Error("Cannot retrieve the selected devices")
                            );
                        }
                    } else {
                        this._message = `Support data from a 3rd Party will be updated for the selected ${this._selectedDeviceIds.length} devices. Select Confirm to continue.\n`;
                        return Promise.resolve();
                    }
                })
                .then(() => {
                    return this._gameEditor.runQuickConfirmationActionWorkflow(
                        {
                            message: this._message,
                            title: "Update Support Data",
                            confirmDetails: {
                                text: "Confirm",
                                type: "additive",
                            },
                            rejectDetails: {
                                text: "Cancel",
                                type: "text",
                            },
                        },
                        () => {
                            let workTarget = {
                                method: "multi",
                                ids: this._selectedDeviceIds,
                            };
                            /*
                            this._modalUserFeedback.displayLoading({
                                message: "Updating Support Data... This could take a moment"
                            });

                             */

                            const showProgFunc = (prog) => {
                                this._modalUserFeedback.showLoadingProgress(
                                    `${prog.successCount} of ${prog.targetCount}`
                                );
                            };

                            this._modalUserFeedback.displayLoading({
                                message: "Updating Support Data... This could take a moment",
                                showHideButton: true,
                            });

                            return this._DeviceEntity
                                .runRetrieveSupportDataWork(
                                    this._activeOrgId,
                                    workTarget,
                                    {},
                                    {launchAndForget: false},
                                    showProgFunc
                                )
                                .then((result) => {
                                    //if hidden early we do not do calc or show
                                    if (result.summary && this._modalUserFeedback.isStillOpen) {
                                        const {targetCount, successCount, failureCount} =
                                            result.summary;

                                        let userNotificationMessage = [
                                            `Total devices: ${targetCount || 0}`,
                                            `Successful devices: ${successCount || 0}`,
                                            `Device failures: ${failureCount || 0}`,
                                        ].join("\r\n");

                                        return this._modalUserFeedback.displayNotification(
                                            userNotificationMessage,
                                            {
                                                title: "Support Data Update Completed",
                                                confirmDetails: {
                                                    text: "OK",
                                                    type: "text",
                                                },
                                            }
                                        );
                                    }
                                })
                                .then(() => {
                                    return this._modalUserFeedback.hideDisplayed();
                                })
                                .catch((err) => {
                                    if (err.userRejected === true) {
                                        return Promise.resolve();
                                    }
                                    return this._modalUserFeedback.displayError({
                                        error: {errorMsg: err},
                                    });
                                });
                        }
                    );
                })
                .catch((err) => {
                    this._logger.warn({error: err}, "UpdateAction.run() - Error");
                    return this._modalUserFeedback.displayError({error: {errorMsg: err}});
                });
        } else {
            return Promise.resolve();
        }
    }
}

module.exports = UpdateCiscoSupportAction;

UpdateCiscoSupportAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "gameEditor.activeView",
    "$teve.userSession",
    "$teve.entities.Device",
];

UpdateCiscoSupportAction.$displayDetails = {
    type: "Action",
    name: "UpdateCiscoSupportAction",
    icon: "devicemanager.api_update",
    shown: true,
    title: "Update Support Data",
    order: 2,
};
